// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SettingsTitle-module__container--ZD5Qg{display:flex;align-items:center;gap:5px;font-weight:700;margin-top:40px}.SettingsTitle-module__container--ZD5Qg .SettingsTitle-module__title--oM39b{font-size:15px;color:#373e44}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SettingsTitle-module__container--ZD5Qg`,
	"title": `SettingsTitle-module__title--oM39b`
};
export default ___CSS_LOADER_EXPORT___;
